<template>
    <div>
        <table class="tracking-listing">
            <thead>
                <tr>
                    <th>{{ physicianHeading }}</th>
                    <th v-if="!isTablet">{{ $t('pages.referrals.index.headings.patient') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.referrals.index.headings.created_at') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.referrals.index.headings.diagnosis') }}</th>
                    <th v-if="!isTablet">{{ $t('pages.referrals.index.headings.status') }}</th>

                    <th>
                        <div class="tracking-listing__filter">
                            <common-icon
                                class="tracking-listing__print"
                                name="print"
                                size="large"
                                @click="printPage"
                            ></common-icon>
                        </div>
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(referral, index) in referrals" :key="index">
                    <td>
                        <user-details
                            :user="physicianData(referral.referralInfo)"
                            :bottomText="physicianSpeciality(referral.referralInfo)"
                        ></user-details>
                    </td>

                    <td v-if="!isTablet">
                        <div class="tracking-listing__patient">
                            <div>
                                <p class="user-details-card__highlited">
                                    <common-patient-name :patient="referral.referralInfo?.patient"></common-patient-name>
                                </p>
                                <p>{{ $t('pages.referrals.index.patient.dob') }}</p>
                                <p>{{ getPatientDateOfBirth(referral.referralInfo.patient) }}</p>
                            </div>
                        </div>
                    </td>

                    <td v-if="!isTablet">
                        {{ getCreatedDate(referral) }}
                    </td>

                    <td v-if="!isTablet" class="tracking-listing__status">{{ referral.referralInfo.diagnosis }}</td>

                    <td v-if="!isTablet" class="tracking-listing__status">
                        <referrals-status :referral="referral"></referrals-status>
                    </td>

                    <td class="listing-listing__action">
                        <referrals-status v-if="isTablet" :showDescriptionText="false" :referral="referral"></referrals-status>
                        <listing-action :type="$route.params.type" :referral="referral"></listing-action>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { isMaskedDateOfBirth } from '~/helpers'
    import dayjs from 'dayjs'
    import ReferralsStatus from 'components/page-elements/ReferralsStatus'
    import UserDetails from 'components/page-elements/referrals/details/UserDetailsCard'
    import ListingAction from 'components/page-elements/referrals-index-listing/ListingAction'
    import DateTimeMixin from 'mixins/DateTimeMixin'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ReferralPathTypeEnum from '@/enums/ReferralPathTypeEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [DateTimeMixin, ScreenSizeDetectionMixin],

        components: {
            ReferralsStatus,
            UserDetails,
            ListingAction,
        },

        props: {
            referrals: { type: Array, required: true },
        },

        computed: {
            physicianHeading() {
                return this.$t('pages.referrals.index.headings.from')
            },
        },

        methods: {
            showPracticeDetails(referral) {
                if (this.type === ReferralPathTypeEnum.RECEIVED) {
                    return referral.fromPractice?.practiceType === PracticeTypeEnum.ANCILLARY
                } else {
                    return referral.practice.practiceType === PracticeTypeEnum.ANCILLARY
                }
            },
            getPracticeDetails(referral) {
                if (this.type === ReferralPathTypeEnum.RECEIVED) {
                    return referral.fromPractice
                } else {
                    return referral.practice
                }
            },
            physicianData(referral) {
                return referral.fromUser
            },
            patientData(referral) {
                return referral.patient || {}
            },
            physicianSpeciality(referral) {
                return referral.fromUser?.specialities[0]?.speciality?.name
            },
            getAppointmentDateIcon(referral) {
                const icon = {
                    name: 'white-warning',
                    size: 'medium',
                    hintHeader: this.$t('pages.referrals.index.warnings.reschedule.hintTitle'),
                    hintText: this.$t('pages.referrals.index.warnings.reschedule.text'),
                }
                const isReschedule = referral.status === 'RESCHEDULE_AVAILABILITY_CHANGE'
                const appointmentDateTime = dayjs(referral.appointmentDateTime)
                const isInNext24h = dayjs().isBefore(appointmentDateTime) && dayjs().add(24, 'h').isAfter(appointmentDateTime)
                return isReschedule && isInNext24h ? icon : null
            },

            getCreatedDate(referral) {
                return dayjs(referral.createdDateTime).format('MMMM D, YYYY')
            },

            getAppointmentLocation(referral) {
                if (referral.practiceLocation && referral.practiceLocation.name) {
                    return referral.practiceLocation.name
                }
                return this.$t('pages.referrals.index.locations.main')
            },

            getUserFullName(patient) {
                return `${patient.firstName} ${patient.lastName}`
            },

            getPatientDateOfBirth(patient) {
                if (isMaskedDateOfBirth(patient?.dateOfBirth)) return '—'
                return dayjs(patient.dateOfBirth).format('MM/DD/YYYY')
            },

            printPage() {
                window.print()
            },
        },

        beforeMount() {
            this.referrals.forEach((referral) => {
                referral.referralInfo.isTemporary = true
            })
        },
    }
</script>
